export default __webpack_public_path__ + "img/priority_Medium.svg";